// store/cacheProfile.js

export const cacheProfilePicture = async (profilePicUrl, userId) => {
    if (!profilePicUrl) return;

    try {
        const response = await fetch(profilePicUrl);
        const blob = await response.blob();

        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
            const base64data = reader.result;
            localStorage.setItem(`profilePic_${userId}`, base64data);
        };
    } catch (error) {
        console.error('Error caching profile picture:', error);
    }
};

export const getCachedProfilePicture = (userId) => {
    return localStorage.getItem(`profilePic_${userId}`);
};

export const clearProfilePictureCache = (userId) => {
    localStorage.removeItem(`profilePic_${userId}`);
};
